
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'tables',
  props: {
    //table数据
    listData: {
      type: Array,
      requird: true
    },
    //table属性
    propList: {
      type: Array,
      requird: true
    },
    //是否显示index列
    showIndexColumn: {
      type: Boolean,
      default: () => false
    },
    //是否显示单选框列
    showSelectColumn: {
      type: Boolean,
      default: () => false
    },
    //标题名
    title: {
      type: String,
      default: () => ''
    },
    /* 分页数据 */
    //条数
    listCount: {
      type: Number,
      default: () => 0
    },
    //默认当前页1,,条数10条
    page: {
      type: Object,
      default: () => ({ currentPage: 1, size: 10 })
    },
    /* 树形表格属性 */
    childrenProps: {
      type: Object,
      default: () => ({})
    },
    /* 是否显示分页功能 */
    showFooter: {
      type: Boolean,
      default: () => true
    }
  },
  emits: ['selectionChange', 'update:page'],
  setup(props, { emit }) {
    /* 单选框选中行数据 */
    const selectionChange = (value: any) => {
      emit('selectionChange', value)
    }
    /* 当前页改变事件 */
    const handleCurrentChange = (currentPage: number) => {
      emit('update:page', { ...props.page, currentPage })
    }
    /* 选择展示条数事件 */
    const handleSizeChange = (size: number) => {
      emit('update:page', { ...props.page, size })
    }
    return {
      selectionChange,
      handleSizeChange,
      handleCurrentChange
    }
  },
  components: {}
})
